export const GET_STUDENTS_REQUEST = 'GET_STUDENTS_REQUEST'
export const GET_STUDENTS_SUCCESS = 'GET_STUDENTS_SUCCESS'
export const GET_STUDENT_SUCCESS = 'GET_STUDENT_SUCCESS'
export const GET_STUDENTS_FAIL = 'GET_STUDENTS_USER_FAIL'
export const EDIT_STUDENT_SUCCESS = 'EDIT_STUDENT_SUCCESS'
